import { Card, CardContent } from "@/components/ui/card"
import { Tagline } from "@/components/pro-blocks/landing-page/tagline"
import { Clock, Eye, BarChart3, Bell, Shield } from "lucide-react"

const benefits = [
  {
    icon: Clock,
    title: "Свободное время для стратегии",
    before: "8 часов в неделю на чтение обращений",
    after: "1.5 часа на просмотр готовых выводов",
    metric: "Экономия 6.5 часов каждую неделю",
  },
  {
    icon: Eye,
    title: "Полная картина вместо выборки",
    before: "Успеваете прочитать 20% обращений",
    after: "Анализируется 100% обращений",
    metric: "Никаких пропущенных проблем",
  },
  {
    icon: BarChart3,
    title: "Решения на основе цифр",
    before: '"Кажется, много жалоб" — и споры',
    after: '"47 обращений, $23K под угрозой" — и решения',
    metric: "Точность приоритизации 90%",
  },
  {
    icon: Bell,
    title: "Раннее обнаружение кризисов",
    before: "Узнаёте о баге через неделю",
    after: "Уведомление в течение 24 часов",
    metric: "С 5-7 дней до 24 часов",
  },
  {
    icon: Shield,
    title: "Уверенность и спокойствие",
    before: 'Постоянное чувство "я что-то упускаю"',
    after: "Спокойствие от того, что система видит всё",
    metric: "Уверенные ответы на любые вопросы",
  },
]

export function BentoGrid6() {
  return (
    <section className="bg-background section-padding-y border-b" id="features">
      <div className="container-padding-x container mx-auto flex flex-col gap-10 md:gap-12">
        <div className="section-title-gap-lg mx-auto flex max-w-xl flex-col items-center text-center">
          <Tagline>Преимущества</Tagline>
          <h2 className="heading-lg">Как изменится ваша работа</h2>
          <p className="text-muted-foreground">
            Вместо 8 часов ручного анализа — 30 минут на просмотр готовых выводов. И уверенность, что ничего не упущено.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          {benefits.map((benefit, index) => (
            <Card key={index} className="bg-muted/50 overflow-hidden rounded-xl border-none p-0 shadow-none">
              <CardContent className="flex flex-col gap-4 p-6">
                <div className="bg-primary/10 flex h-12 w-12 items-center justify-center rounded-xl">
                  <benefit.icon className="text-primary h-6 w-6" />
                </div>
                <h3 className="text-foreground text-lg font-semibold">{benefit.title}</h3>
                <div className="flex flex-col gap-2">
                  <div className="flex items-start gap-2">
                    <span className="text-destructive mt-0.5 text-sm font-medium">Было:</span>
                    <span className="text-muted-foreground text-sm">{benefit.before}</span>
                  </div>
                  <div className="flex items-start gap-2">
                    <span className="text-primary mt-0.5 text-sm font-medium">Стало:</span>
                    <span className="text-muted-foreground text-sm">{benefit.after}</span>
                  </div>
                </div>
                <div className="bg-primary/5 rounded-lg p-3">
                  <span className="text-primary text-sm font-medium">{benefit.metric}</span>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  )
}
